import { graphql } from '@/gql';
import type { AddGroceryToCartMutationVariables } from '@/gql/graphql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const addGroceryToCart = async ({ orderId, email, isClearPreviousItems }: AddGroceryToCartMutationVariables): Promise<string> => {
  const response = await mutationExecute({
    mutation: graphql(`
      mutation AddGroceryToCart($orderId: String!, $email: String, $isClearPreviousItems: Boolean) {
        addGroceryToCart(orderId: $orderId, email: $email, isClearPreviousItems: $isClearPreviousItems)
      }
    `),
    variables: {
      orderId,
      email,
      isClearPreviousItems,
    },
  });

  return response.data?.addGroceryToCart!;
};
